<template>
  <v-dialog
    v-model="visible"
    scrollable
  >
    <v-card color="basil">
      <v-card-title>选择角色</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 300px;">
        <v-radio-group
          v-model="role_id"
          column
        >
          <v-radio v-for="item in roleList" :key="item.role_id"
            :label="item.role_name"
            :value="item.role_id"
          ></v-radio>
        </v-radio-group>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click="$emit('close')"
        >
          关 闭
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="selectRole"
        >
          确 认
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      timeout="1500"
      absolute
      top
      style="text-align:center"
      color="#c56060"
      v-model="snackbar"
    >
        {{snackInfo}}
    </v-snackbar>
  </v-dialog>
</template>

<script>
import * as login from '@/api/index'
export default {
    name: 'Login',
    props: {
        visible: Boolean,
        roleList: Array,
    },
    data () {
        return {
            role_id: '',
            snackbar: false,
            snackInfo: '登录错误，请稍后再试'
        }
    },
    computed: {
    },
    methods: {
      async selectRole() {
        const {role_id} = this
        await login.selectRole({role_id: role_id})
            .then(res => {
              this.handleSucc(res)
            })
            .catch(err => {
              this.handleFail(err)
            })
      },
      handleSucc(data) {
        console.log({data})
        localStorage.setItem('token', data.token)
        localStorage.setItem('role_name', data.role_name)
        localStorage.setItem('status', 'login')
        this.$emit('succ')
      },
      handleFail(res) {
          this.snackbar = true
          this.snackInfo = res.code === 50000 ? '登录失败' : '登录错误，请稍后再试'
          console.log(res)
      }
    }
};
</script>

<style>
</style>